import React from 'react'
import { useForm } from "react-hook-form";
import { Modal, Form, Button } from 'react-bootstrap'
import { inject, observer } from 'mobx-react'
import apiService from 'Service'
import { useTranslation } from 'react-i18next'
import uiStore from 'stores/uiStore'

const InvitationModal = ({ toCompany, parentShowState, parentClose, authStore, companyStore }) => {
    const { register, handleSubmit, formState: { isSubmitting } } = useForm();
    const { t } = useTranslation()

    const targetCompany = companyStore.ownCompanies
        .flatMap(m => (m.Companies || []).map(c => ({
            ...c,
            Keymembership: c.Keymembership || m.Keymembership,
        })))
        .find(c => c.Keycompany === toCompany)

    const onSubmit = data => {
        const headers = {}
        if (targetCompany?.Keymembership) headers.keyMembership = targetCompany.Keymembership
        if (toCompany) headers.keyCompany = toCompany

        return apiService.Account.guestGenerate(data.email, toCompany, headers).then(() => {
            parentClose()
            uiStore.notifySuccess(t('invitation_sent') || 'Invitación enviada')
        }).catch(() => {
            uiStore.notifyError(t('error_saving_data'))
        })
    };

    function hanldeModalClose() {
        parentClose()
    }

  const companyName = targetCompany?.BusinessName

    return (
        <Modal show={parentShowState} onHide={hanldeModalClose}>
            <Modal.Header closeButton closeLabel={t('close')}>
                <Modal.Title>{t('invite') || 'Invitar'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {companyName && <p className="text-muted">{companyName}</p>}
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group controlId="ivEmail">
                        <Form.Label>{t('email') || 'Correo'}</Form.Label>
                        <Form.Control type="email" required name="email" ref={register} />
                    </Form.Group>
                    <Button type="submit" disabled={isSubmitting}>
                        {t('invite') || 'Invitar'}
                    </Button>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={hanldeModalClose}>
                    {t('close') || 'Cerrar'}
                </Button>
            </Modal.Footer>
        </Modal >
    )
}

export default inject('authStore', 'companyStore')(observer(InvitationModal))
